import { PrivateBillCostCenter } from "@/Common/Components/Billing/PrivateBillCostCenter";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";

class CostCenterUIModel implements ICheckable {
    public Id: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Visible: boolean;
    public Model: PrivateBillCostCenter;

    constructor() {
        this.Id = "";
        this.Name = "";
        this.Checked = false;
        this.Target = CheckboxTarget.Unassigned;
        this.Visible = true;
    }

    public Clone(): CostCenterUIModel {
        var center = new CostCenterUIModel();

        center.Id = this.Id;
        center.Name = this.Name;
        center.Checked = this.Checked;
        center.Target = this.Target;
        center.Visible = this.Visible;
        return center;
    }

    public static FromCompositeObject(costCenter: PrivateBillCostCenter): CostCenterUIModel {
        var o = new CostCenterUIModel();
        o.Id = costCenter.ID;
        o.Name = costCenter.Name;
        o.Visible = true;
        o.Model = costCenter;
        return o;
    }
}

export { CostCenterUIModel };
